export enum TileHexType {
    Desert = 0,
    Lumber = 1,
    Brick = 2,
    Wool = 3,
    Grain = 4,
    Ore = 5,
    Gold = 6,
    Fog = 7,
    Sea = 8,
}

export interface TileHexState {
    readonly x: number
    readonly y: number
    type: TileHexType
    diceNumber: number
}
